import api from '@/api/api'
import Header from '@/components/Header'
import Bottom from '@/components/Bottom'
import dataStatistics from '@/assets/js/dataStatistics'
export const articleListMixin = {
  components: { Header, Bottom },
  data() {
    return {
      isLight: false,
      isMenuLight: false,
      currentPage: 1,
      totalPages: 0,
      list: []
    }
  },
  created() {
    this.getList(1)
    this.dataStatisticsType()
  },
  methods: {
    handleToDetail(id) {
      this.$router.push({
        path: 'articleDetail',
        query: {
          from: this.articleType,
          id
        }
      })
    },
    dataStatisticsType() {
      const type = this.articleType
      if (type === 2) {
        dataStatistics('PC-新闻动态页', '进入', '文章浏览')
      } else if (type === 3) {
        dataStatistics('PC-公告通知页', '进入', '文章浏览')
      } else if (type === 4) {
        dataStatistics('PC-规章制度页', '进入', '文章浏览')
      } else if (type === 5) {
        dataStatistics('PC-行业共治页', '进入', '文章浏览')
      } else if (type === 6) {
        dataStatistics('PC-风控TV页', '进入', '文章浏览')
      }
    },
    getList(page) {
      const params = {
        type: this.articleType,
        pageNum: page,
        pageSize: this.pageNum || 6
      }
      api.article.articleList(params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data.list
          this.totalPages = res.data.data.total
        }
      })
    },
    handlePageChange(page) {
      this.getList(page)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/articleListMixin.js